export default __webpack_public_path__ + "static/media/VS.6ae5fd10.png";